import { connect } from 'react-redux';

import { getIsAuthenticated } from 'ha/modules/AuthLogic/selectors';
import { GlobalState } from 'ha/types/store';
import SearchAlertDesktop from '../../components/SearchAlerts/SearchAlertDesktop';
import { isSearchAlertDisabled } from '../../selectors';

export default connect((state: GlobalState) => ({
  isAuthenticated: getIsAuthenticated(state),
  isDisabled: isSearchAlertDisabled(state),
}))(SearchAlertDesktop);
